import dayjs from 'dayjs'
import { useMemo } from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { actions as swapOrReturnActions } from 'src/features/swap-or-return/SwapOrReturnState'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { formatDifferenceFromNow } from 'src/utils/formatDifference'
import { columns } from './SupplierReleaseTab.columns'
import * as S from './SupplierReleaseTab.styles'

interface NotReleasedReceivement {
  id_receivement: number
  supplier_name: string
  finished_at: Date
}

interface SupplierReleaseTabProps {
  notReleasedReceivements: NotReleasedReceivement[]
}

export const SupplierReleaseTab = ({
  notReleasedReceivements,
}: SupplierReleaseTabProps) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const release = (supplierName: string, idReceivement: number) => {
    dispatch(swapOrReturnActions.setProperty({
      property: 'pendingsToPrint',
      value: {
        supplierName,
        pendings: [
          { idReceivement },
        ],
      },
    }))
    history.push('/invoices/release/receivement')
  }

  const createRowData = (receivement: NotReleasedReceivement) => {
    const fininshedDate = dayjs(receivement.finished_at)

    return {
      supplier: receivement.supplier_name,
      finishedAt: fininshedDate.format('DD/MM/YYYY H:mm'),
      time: formatDifferenceFromNow(fininshedDate),
      action: (
        <S.CustomButton
          title='Liberar'
          onClick={() => release(receivement.supplier_name, receivement.id_receivement)}
          testId='release-button-test-id'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          size='small'
        />
      ),
    }
  }

  const tableSize = useMemo(
    () => (notReleasedReceivements.length < 10 ? 10 : notReleasedReceivements.length), [notReleasedReceivements],
  )

  return (
    <S.Wrapper>
      <ReactTable
        style={{ height: '100%' }}
        data={notReleasedReceivements.map(createRowData)}
        showPagination={false}
        columns={columns as any}
        defaultPageSize={tableSize}
        pageSize={tableSize}
        className='-striped -highlight'
        previousText='Anterior'
        nextText='Próxima'
        loadingText='Carregando...'
        noDataText='Sem registros'
        pageText='Página'
        ofText='de'
        rowsText='Registros'
      />
    </S.Wrapper>
  )
}
